export default function ({ app, store }) {
  for (const locale in store.state.messages) {
    app.i18n.setLocaleMessage(locale, store.state.messages[locale])
  }
}
